import { Content, VerticalSpace } from '@elhub/ds-components'
import TopContainer from 'components/TopContainer/TopContainer'
import Feedback from '../components/Feedback'
import { ThemeSwitcherProvider } from 'react-css-theme-switcher'
import React from 'react'
import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'
import { useAppSelector } from '../store'
import { getHost } from '../utils/getHost'
import { getApiDocUrl } from '../utils/getApiDocUrl'
import { useParams } from 'react-router-dom'

// @ts-expect-error
SwaggerUI.config.defaults.syntaxHighlight.activated = false

const themes = {
  light: 'static/css/SwaggerLight.css',
  dark: 'static/css/SwaggerDark.css'
}

const TryItOut = () => {
  const { api } = useParams()
  const _api = api?.toString() ?? 'energy-data'

  const theme = useAppSelector((state) => state.app.theme)
  const urls: Record<string, string> = {
    'energy-data': getHost() + getApiDocUrl()
  }

  return (
    <TopContainer>
      <Content style={{ maxWidth: '1200px' }}>
        <ThemeSwitcherProvider defaultTheme={theme} themeMap={themes}>
          <SwaggerUI url={urls[_api]} deepLinking docExpansion='list' />
        </ThemeSwitcherProvider>
        <VerticalSpace size='2' />
        <Feedback location='EnergyData API Endpoints page' />
      </Content>
    </TopContainer>
  )
}

export default TryItOut
